import { FC, memo, useCallback, useMemo } from 'react'
import { Seo } from 'components'

import { OrderCopyForm } from '../OrderCopyRoute/OrderCopyForm'
import { transform } from './helpers'

export const OrderRedirectPage: FC = () => {
  const data = useMemo(() => {
    const orderFormData = sessionStorage.getItem('orderFormData')

    return orderFormData ? JSON.parse(orderFormData) : null
  }, [])

  const initial = useMemo(() => {
    if (data) {
      return transform(data)
    }
  }, [data])

  const handleSuccess = useCallback(() => {
    sessionStorage.removeItem('orderFormData')
  }, [])

  return (
    <>
      <Seo
        description="Создание новой заявки для размещения в сервисе доставки сборных грузов QP5 Express. Заполнение данных о грузе и предварительный расчет стоимости грузоперевозки."
        title="Новая заявка – сборные перевозки QP5 Express"
      />
      <OrderCopyForm initial={initial} onFailure={handleSuccess} onSuccess={handleSuccess} />
    </>
  )
}

export default memo(OrderRedirectPage)
